/* eslint-disable no-undef */
import React, { useContext } from 'react';

import { USER_TYPE } from 'interfaces/user';
import { LABELS } from 'utils/labels';

import OnboardingTemplate from 'components/templates/pageTemplate/OnboardingTemplate';
import CapitalAdvisorTemplate from 'components/templates/pageTemplate/CapitalAdvisorTemplate';

import ApplicationContext from 'contexts/ApplicationContext';
import BusinessRegistrationForm from 'components/features/onboarding/BusinessRegistrationForm';

const BusinessRegistrationPage: React.FC = () => {
  const { userType } = useContext(ApplicationContext);

  const props = {
    dataTestId: 'business-registration-page',
    showHeader: true,
    stepName: LABELS[userType]['step_1'].stepName,
    headerTitle: LABELS[userType]['step_1'].headerTitle,
    hideLegal: false
  };

  const Template =
    userType === USER_TYPE.CAPITAL_ADVISOR
      ? CapitalAdvisorTemplate
      : OnboardingTemplate;

  return (
    <Template {...props}>
      <BusinessRegistrationForm />
    </Template>
  );
};

export default BusinessRegistrationPage;
